export default __webpack_public_path__ + "static/office-tutaev-f012e430d42ee96e2225817fd1786c20.png";